import { BaseResponse } from '@kts-front/types';

import { ENDPOINTS } from 'configs/endpoints';
import { logApiErrWithSentry } from 'scripts/initSentry';
import { logZodError } from 'utils/logZodError';

import { apiStore } from '../../ApiStore';

import { AppConfigServer, IAppConfigService } from './types';
import { AppConfig, AppConfigFetchErrorData, appConfigSchema } from './types/client';

export class AppConfigService implements IAppConfigService {
  async fetchData(): Promise<BaseResponse<AppConfig, AppConfigFetchErrorData>> {
    const response = await apiStore
      .createRequest<AppConfigServer>({ url: ENDPOINTS.config.get(), method: 'GET' })
      .call();

    if (response.isError) {
      logApiErrWithSentry({
        endpoint: ENDPOINTS.config.get(),
        method: 'GET',
        requestPayload: {},
        response,
      });

      return {
        isError: true,
        data: {
          parsingErrors: [],
          httpStatusCode: 'rawError' in response ? response.rawError.response?.status : undefined,
        },
      };
    }

    const parsedConfigResult = appConfigSchema.safeParse(response.data);

    if (!parsedConfigResult.success) {
      logZodError(parsedConfigResult.error);

      const parsingErrors = parsedConfigResult.error.errors.map((error) => ({
        path: error.path.join('.'),
        message: error.message,
      }));

      return {
        isError: true,
        data: {
          parsingErrors,
        },
      };
    }

    return { isError: false, data: parsedConfigResult.data };
  }
}

export const appConfigService = new AppConfigService();
